// trailerUtils.js
export function assignProductsToCompartments(
    orderDetails,
    trailer,
    limits,
    products
) {
    let compartments = [];
    const trailerLimit = limits[trailer.NumAxles] || 0;
    let totalUsage = 0;
    let errorMessages = {};

    console.log('Starting assignment of products to compartments.');

    // Create compartments array based on trailer's compartments
    for (let i = 1; i <= 6; i++) {
        let capacity = trailer[`Comp${i}`];
        if (capacity) {
            compartments.push({
                compartment: i,
                capacity: capacity,
                usage: 0,
                product: null
            });
        }
    }

    console.log('Initialized compartments:', compartments);

    // Calculate total compartment capacity
    const totalCompartmentCapacity = compartments.reduce(
        (sum, comp) => sum + comp.capacity,
        0
    );
    let remainingTrailerCapacity = Math.min(
        trailerLimit,
        totalCompartmentCapacity
    );

    console.log('Total compartment capacity:', totalCompartmentCapacity);
    console.log('Trailer limit based on axles:', trailerLimit);
    console.log('Remaining trailer capacity:', remainingTrailerCapacity);

    // Map of productId to orderDetail for easy access
    const productOrderDetails = {};
    orderDetails.forEach(detail => {
        productOrderDetails[detail.ProductType] = detail;
    });

    // Gather product data (including adjusted quantities if "L.S.D.")
    const productsData = orderDetails.map(orderDetail => {
        const productId = orderDetail.ProductType;
        const originalQuantity = parseInt(orderDetail.ProductQuantity);

        const product = products.find(p => p.ProductID === productId);
        const isLSD = product && product.WeightType === 'L.S.D.';
        const adjustedQuantity = isLSD
            ? Math.ceil(originalQuantity * 1.14)
            : originalQuantity;

        console.log(
            `Product ID: ${productId}, Original Quantity: ${originalQuantity}, ` +
                `Adjusted Quantity: ${adjustedQuantity}, Is L.S.D.: ${isLSD}`
        );

        return {
            productId,
            originalQuantity,
            adjustedQuantity,
            isLSD
        };
    });

    // Sort products by adjusted quantity descending
    productsData.sort((a, b) => b.adjustedQuantity - a.adjustedQuantity);

    // Sort compartments by capacity descending
    const compartmentsByCapacityDesc = [...compartments].sort(
        (a, b) => b.capacity - a.capacity
    );

    // Assign products to compartments
    for (const productData of productsData) {
        let {
            productId,
            originalQuantity,
            adjustedQuantity,
            isLSD
        } = productData;
        let adjustedQuantityToAssign = adjustedQuantity;
        let assignedAdjustedQuantity = 0;

        console.log(
            `Assigning product ${productId} with adjusted quantity ${adjustedQuantity}`
        );

        for (const compartment of compartmentsByCapacityDesc) {
            if (adjustedQuantityToAssign <= 0) break;

            if (compartment.product === null) {
                let availableCapacity = compartment.capacity;
                let quantityToLoad = Math.min(
                    adjustedQuantityToAssign,
                    availableCapacity,
                    remainingTrailerCapacity
                );

                if (quantityToLoad > 0) {
                    compartment.usage = quantityToLoad;
                    assignedAdjustedQuantity += quantityToLoad;
                    adjustedQuantityToAssign -= quantityToLoad;
                    totalUsage += quantityToLoad;
                    remainingTrailerCapacity -= quantityToLoad;
                    compartment.product = productId;

                    console.log(
                        `Assigned ${quantityToLoad} to compartment ${compartment.compartment} ` +
                            `(Product ${productId}). Remaining to assign: ${adjustedQuantityToAssign}`
                    );
                }
            }
        }

        // Calculate the assigned original quantity
        let assignedOriginalQuantity = assignedAdjustedQuantity;
        if (isLSD) {
            assignedOriginalQuantity = Math.floor(
                assignedAdjustedQuantity / 1.14
            );
        }

        console.log(
            `Product ${productId} assigned adjusted quantity: ${assignedAdjustedQuantity}, ` +
                `assigned original quantity: ${assignedOriginalQuantity}`
        );

        // Update orderDetail.ProductQuantity to the assigned original quantity
        const orderDetail = productOrderDetails[productId];
        orderDetail.ProductQuantity = assignedOriginalQuantity;

        // Handle error message if not all requested quantity could be assigned
        if (assignedAdjustedQuantity < adjustedQuantity) {
            errorMessages[productId] = `Requested quantity ${originalQuantity}${
                isLSD ? ' (adjusted to ' + adjustedQuantity + ')' : ''
            } exceeds available capacity. Assigned ${assignedOriginalQuantity}${
                isLSD ? ' (adjusted to ' + assignedAdjustedQuantity + ')' : ''
            }.`;

            console.error(errorMessages[productId]);
        }
    }

    console.log('Final compartment assignments:', compartments);
    console.log('Total usage:', totalUsage);
    console.log('Error messages:', errorMessages);

    return { compartments, totalUsage, trailerLimit, errorMessages };
}
